import { render, staticRenderFns } from "./RolesOffice.vue?vue&type=template&id=699c8b48&scoped=true&"
import script from "./RolesOffice.vue?vue&type=script&lang=js&"
export * from "./RolesOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c8b48",
  null
  
)

export default component.exports